/* Shoppable lookbook — prev/next + optional autoplay. ~0.7KB. */
(function () {
  document.querySelectorAll('[data-lb]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.lb__slide'));
    if (slides.length < 2) return;
    var prev = root.querySelector('[data-lb-prev]');
    var next = root.querySelector('[data-lb-next]');
    var interval = parseInt(root.getAttribute('data-lb-autoplay'), 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    }
    function reset() {
      if (!interval || reduce) return;
      clearInterval(timer);
      timer = setInterval(function () { show(i + 1); }, interval);
    }
    if (prev) prev.addEventListener('click', function () { show(i - 1); reset(); });
    if (next) next.addEventListener('click', function () { show(i + 1); reset(); });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', reset);
    reset();
  });
})();
